const xogAfterGetData = async (id, data) => {
  // if (id != 2) return data;
  if (window.innerWidth < 577) {
    data.images.forEach((image, index) => {
      image.colWidth = 1;
      image.colHeight = 1;
    });
    data.type = "masonry";
  }
  return data;
}